export default __webpack_public_path__ + "static/media/263.96ed43ab.svg";